package com.rainbowclubs.rainbow.presentation.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.rainbowclubs.rainbow.domain.repositories.ClubImageUpload
import kotlinx.browser.document
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Uint8Array
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader

@Composable
actual fun rememberClubImagePicker(
    onImageSelected: (ClubImageUpload) -> Unit,
): () -> Unit {
    return remember(onImageSelected) {
        {
            val input = (document.createElement("input") as HTMLInputElement).apply {
                type = "file"
                accept = "image/*"
                style.display = "none"
            }

            input.onchange = {
                val file = input.files?.item(0)
                if (file != null) {
                    val reader = FileReader()
                    reader.onload = {
                        val arrayBuffer = reader.result as? ArrayBuffer
                        if (arrayBuffer != null) {
                            val array = Uint8Array(arrayBuffer)
                            val bytes = ByteArray(array.length) { index ->
                                (array.asDynamic()[index] as Number).toByte()
                            }

                            onImageSelected(
                                ClubImageUpload(
                                    bytes = bytes,
                                    fileName = file.name,
                                    contentType = file.type.ifBlank { "image/*" },
                                )
                            )
                        }
                        input.remove()
                        null
                    }
                    reader.readAsArrayBuffer(file)
                }
                null
            }

            document.body?.appendChild(input)
            input.click()
        }
    }
}
